import {NgModule} from '@angular/core';
import {ElementFiltersComponent} from './element-filters/element-filters.component';
import {SharedProviderModule} from '../shared/shared.module';
import {ElementActionsComponent} from './element-actions/element-actions.component';
import {NgbDropdownModule, NgbTooltipModule} from '@ng-bootstrap/ng-bootstrap';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { FlagActionComponent } from './element-actions/flag-action/flag-action.component';
import { FocusActionComponent } from './element-actions/focus-action/focus-action.component';
import { InfoActionComponent } from './element-actions/info-action/info-action.component';
import { FollowTrainModule } from '../custom/vrgroup/follow-train/follow-train.module';
import { MeasurementsActionComponent } from './element-actions/measurements-action/measurements-action.component';

@NgModule({
  imports: [
    SharedProviderModule,
    NgbDropdownModule,
    FontAwesomeModule,
    FollowTrainModule,
    NgbTooltipModule
  ],
  declarations: [ElementFiltersComponent, ElementActionsComponent, FlagActionComponent,
    FocusActionComponent, InfoActionComponent, MeasurementsActionComponent],
  exports: [ElementFiltersComponent, ElementActionsComponent]
})
export class ElementUtilsModule {
}
